import { fg } from '@atlassian/jira-feature-gating';

const projectsInJiraGaDropRelayProvider = {
	get(): boolean {
		return fg('projects_in_jira_ga_drop');
	},
};

export default projectsInJiraGaDropRelayProvider;
